var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
import qs from 'qs';
import { ShareValues } from './ShareValues';
import { sleep } from './sleep';
export var MethodType;
(function (MethodType) {
    MethodType["POST"] = "POST";
    MethodType["PATCH"] = "PATCH";
    MethodType["GET"] = "GET";
    MethodType["PUT"] = "PUT";
    MethodType["DELETE"] = "DELETE";
})(MethodType || (MethodType = {}));
export function createApiCall(_a) {
    var _b = _a.method, method = _b === void 0 ? 'GET' : _b, _c = _a.url, url = _c === void 0 ? '' : _c, _d = _a.data, data = _d === void 0 ? {} : _d, _e = _a.auth, auth = _e === void 0 ? false : _e, _f = _a.includeTenant, includeTenant = _f === void 0 ? true : _f, _g = _a.authGuestToken, authGuestToken = _g === void 0 ? '' : _g, _h = _a.includeTenantInURL, includeTenantInURL = _h === void 0 ? false : _h, abortController = _a.abortController, _j = _a.checkSelectedGrant, checkSelectedGrant = _j === void 0 ? true : _j;
    return __awaiter(this, void 0, void 0, function () {
        var headers, selectedGrant, authResultTokenAccess, grant_id, customer_number, extraData, responseData, jsonError, result, error_1;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    _k.trys.push([0, 8, , 9]);
                    headers = { 'Content-Type': 'application/json' };
                    selectedGrant = ShareValues.getData().selectedGrant;
                    authResultTokenAccess = ShareValues.getAuthResultTokenAccess();
                    if (!!authGuestToken) return [3 /*break*/, 3];
                    _k.label = 1;
                case 1:
                    if (!((checkSelectedGrant && !selectedGrant) || !authResultTokenAccess)) return [3 /*break*/, 3];
                    // eslint-disable-next-line no-await-in-loop
                    return [4 /*yield*/, sleep(100)];
                case 2:
                    // eslint-disable-next-line no-await-in-loop
                    _k.sent();
                    return [3 /*break*/, 1];
                case 3:
                    if (auth && !authGuestToken)
                        headers.Authorization = "Bearer ".concat(authResultTokenAccess);
                    if (authGuestToken)
                        headers.Authorization = "".concat(authGuestToken);
                    grant_id = (selectedGrant || { id: undefined }).id;
                    customer_number = selectedGrant ? selectedGrant.accounts[0].customer_number : undefined;
                    extraData = includeTenant && !authGuestToken ? __assign(__assign({}, data), { tenant_id: grant_id, customer_number: customer_number }) : __assign({}, data);
                    if (method === 'GET' || method === 'DELETE') {
                        url += (!url.includes('?') ? '?' : '&') + qs.stringify(extraData, { encode: false, arrayFormat: 'brackets' });
                    }
                    if (includeTenantInURL) {
                        url
                            += (!url.includes('?') ? '?' : '&')
                                + qs.stringify({ tenant_id: grant_id, customer_number: customer_number }, { encode: false, arrayFormat: 'brackets' });
                    }
                    return [4 /*yield*/, fetch(url, {
                            body: method !== 'POST' && method !== 'PUT' && method !== 'PATCH' ? undefined : JSON.stringify(extraData),
                            cache: 'no-cache',
                            headers: headers,
                            method: method,
                            signal: abortController ? abortController.signal : undefined,
                        })];
                case 4:
                    responseData = _k.sent();
                    if (!(responseData.status >= 300)) return [3 /*break*/, 6];
                    return [4 /*yield*/, responseData.json()];
                case 5:
                    jsonError = _k.sent();
                    if (jsonError && jsonError.errors && jsonError.errors.base) {
                        throw Error(jsonError.errors.base.join(','));
                    }
                    throw Error(JSON.stringify(jsonError.errors));
                case 6: return [4 /*yield*/, responseData.json()];
                case 7:
                    result = _k.sent();
                    return [2 /*return*/, { body: result, status: responseData.status, aborted: false }];
                case 8:
                    error_1 = _k.sent();
                    return [2 /*return*/, { body: error_1, status: 500, aborted: error_1.code === 20 }];
                case 9: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=createAPICall.js.map